import HeroSection from "../components/HeroSection";
import AboutUs from "../components/AboutUs";
import Solutions from "../components/Solutions";
import WhyChooseUs from "../components/WhyChooseUs";

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutUs />
      <Solutions />
      <WhyChooseUs />
    </>
  );
}
